import { AnyAction } from 'redux';
import {
  GlobalActions,
  VersicherungsnehmerCommonInsuranceData,
} from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import { Tarifbereich } from '@ps20/bff-models';
import {
  App,
  determineAssekuranztarifFromTarifbereich,
  VwgVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import { VwgActions } from '../vwgActions';
import { IAppState } from '../appState';

export interface Versicherungsnehmer extends VersicherungsnehmerCommonInsuranceData {
  tarifbereich?: Tarifbereich;
}

export const versicherungsnehmerReducer = function (
  sectionState: Versicherungsnehmer = null,
  action: AnyAction,
  appState: IAppState,
): Versicherungsnehmer {
  switch (action.type) {
    case VwgActions.GEBURTSDATUM_CHANGED: {
      return {
        ...sectionState,
        geburtsdatum: action.payload.geburtsdatum,
      };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const newState: Versicherungsnehmer = cloneDeep(sectionState);
      if (action.payload.versicherungsnehmer?.geburtsdatum) {
        const dateSplitted = action.payload.versicherungsnehmer.geburtsdatum.split('-');
        newState.geburtsdatum = `${dateSplitted[2]}.${dateSplitted[1]}.${dateSplitted[0]}`;

        return newState;
      } else {
        return sectionState;
      }
    }
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD:
    case GlobalActions.UPDATE_ASSEKURANZTARIF_DATA: {
      return {
        ...sectionState,
        isAssekuranztarif: action.payload,
      };
    }
    case GlobalActions.TARIFBEREICH_CHANGED: {
      return {
        ...sectionState,
        tarifbereich: action.payload,
        isAssekuranztarif: determineAssekuranztarifFromTarifbereich(action.payload),
      };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VwgVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.VWG_V2 && actionPayload.angebotsId === appState.angebotsId) {
        let gebDatum = sectionState.geburtsdatum;
        if (actionPayload.geburtsdatumVn) {
          const dateSplitted = actionPayload.geburtsdatumVn.split('-');
          gebDatum = `${dateSplitted[2]}.${dateSplitted[1]}.${dateSplitted[0]}`;
        }
        return { ...sectionState, geburtsdatum: gebDatum };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
